<p-toast position="bottom-left" [preventOpenDuplicates]="true">
    <!-- <ng-template let-message pTemplate="message">
        <div class="ui-toast-message-text-content">
            <i class="ui-toast-icon pi pi-check" style="font-size: 3rem"></i>
            <h4 class="ui-toast-summary">{{message.summary}}</h4>
            <div class="ui-toast-detail" [innerHtml]="message.detail"></div>
        </div>
    </ng-template> -->
</p-toast>

<p-confirmDialog class="ui-rtl custom-message" [acceptLabel]="'GENERAL.OK'|translate" [rejectLabel]="'GENERAL.CANCEL'|translate"></p-confirmDialog>